import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const TimelineDottedLine = styled(Box)(({ theme }) => ({
  borderLeft: '2px dashed #cbcbcb',
  height: '100%',
  width: '0px'
}));

export const GridContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '20px auto',
  gridTemplateRows: '10px 20px auto',
  columnGap: '10px'
}));

export const GridItem = styled(Box)(({ theme }) => ({
  display: 'grid',
  justifyItems: 'center',
  alignItems: 'flex-end'
}));

export const ThreeRowItem = styled(Box)(({ theme }) => ({
  gridRow: 'span 3'
}));
